import { Component, Input } from '@angular/core';
import { Design } from 'src/app/models/domain';

@Component({
  selector: 'em-general-information',
  styleUrls: ['./general-information.component.less'],
  templateUrl: './general-information.component.html',
  standalone: false,
})
export class GeneralInformationComponent {
  @Input() public design?: Design;
  @Input() public error = '';
  @Input() public loading = false;
}
